import predicates from '../predicates'
import { DIRECT_TRAFFIC_ID, DIRECT_TRAFFIC_SOURCE } from '../constants'

const direct = {
  rule: predicates.not(
    predicates.referrerExists(),
    predicates.searchParamIncludesOne('utm_medium', 'utm_source')
  ),
  extractor: traffic => {
    const trafficSource = DIRECT_TRAFFIC_SOURCE
    const trafficId = DIRECT_TRAFFIC_ID

    return {
      trafficSource,
      trafficId,
    }
  },
}

export default direct



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/vms/ads/trafficAnalyzer/pipelines/direct.js